/**
 * @fileoverview Model for the identifier of a given override field.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import {OverrideFieldType} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/overridefieldtype';

export class OverrideFieldKey {
  /**
    * @param {{
    *  id: number,
    *  type: OverrideFieldType,
    * }} params
    */
  constructor(params) {
    /** @type {number} */
    this.id = params.id;
    /** @type {OverrideFieldType} */
    this.type = params.type;
  }

  /**
   * @returns {!OverrideFieldKeyJson}
   */
  toJSON() {
    return {
      'id': this.id,
      'type': this.type,
    };
  }

  /**
    * @param {!OverrideFieldKeyJson} json
    * @return {!OverrideFieldKey}
    */
  static fromJSON(json) {
    return new OverrideFieldKey({
      id: json['id'],
      type: json['type'],
    });
  }
}

/**
  * @dict
  * @typedef {{
  *  id: number,
  *  type: string,
  * }}
  */
export let OverrideFieldKeyJson;
